import { FC } from 'react';
import { Title, Text, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

// -----------------------------------------------------------------------------
interface GrowthChartHeaderProps {
  chartType: string;
  gender: 'male' | 'female';
  ageRange: string;
}

// -----------------------------------------------------------------------------
export const GrowthChartHeader: FC<GrowthChartHeaderProps> = ({
  chartType,
  gender,
  ageRange,
}) => {
  const { t } = useTranslation('patient-pages');
  const genderText =
    gender === 'male'
      ? t('growthCharts.controls.boys')
      : t('growthCharts.controls.girls');
  // Handle age range translation using the full key
  const ageRangeLabel = t(('growthCharts.ageRanges.' + ageRange) as any);

  let chartTypeKey;
  if (chartType === 'weight_for_length') {
    chartTypeKey = 'weightForLength';
  } else if (chartType === 'height') {
    chartTypeKey = 'lengthForAge';
  } else if (chartType === 'weight') {
    chartTypeKey = 'weightForAge';
  } else if (chartType === 'bmi') {
    chartTypeKey = 'bmiForAge';
  } else if (chartType === 'head_circumference') {
    chartTypeKey = 'headCircumferenceForAge';
  } else {
    chartTypeKey = 'lengthForAge';
  }
  const chartTitle = `${t(
    ('growthCharts.titles.' + chartTypeKey) as any
  )} (${genderText}, ${ageRangeLabel})`;
  return (
    <Stack gap="sm">
      <Title order={3} w={500}>
        {chartTitle}
      </Title>
      <Text size="sm" c="dimmed">
        {t('growthCharts.source')}: World Health Organization (WHO)
      </Text>
    </Stack>
  );
};
